<div class="monitoramento-container">
  <div class="monitoramento-tabs" role="tablist" aria-label="Monitoramento">
    <button type="button" role="tab" [class.active]="section() === 'alerts'" (click)="section.set('alerts')">Alertas</button>
  </div>

  @if (section() === 'alerts') {
    <div class="monitoramento-subtabs" role="tablist" aria-label="Alertas">
      <button
        type="button"
        role="tab"
        [class.active]="alertTab() === 'cadastro'"
        (click)="alertTab.set('cadastro')">
        Cadastro
      </button>
      <button
        type="button"
        role="tab"
        [class.active]="alertTab() === 'historico'"
        (click)="alertTab.set('historico')">
        Histórico
      </button>
    </div>

    <div class="monitoramento-card">
      @if (alertTab() === 'cadastro') {
        <app-alerts-panel></app-alerts-panel>
      } @else {
        <app-alarms-panel></app-alarms-panel>
      }
    </div>
  } @else {
  <div class="monitoramento-card">
    <div class="monitoramento-card__header">
      <h2 class="monitoramento-card__title">Evolução da duração total das execuções</h2>
      <p class="monitoramento-card__subtitle">Duração total &amp; volume de séries</p>
    </div>

    @if (isLoading()) {
      <div class="monitoramento-card__loading">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Carregando dados...</span>
      </div>
    } @else if (hasError()) {
      <empty-state
        [title]="'Não foi possível carregar os dados'"
        [description]="'Tente novamente mais tarde.'">
      </empty-state>
    } @else if (!hasData()) {
      <empty-state
        [title]="'Nenhuma execução encontrada'"
        [description]="'Não há dados de execuções em lote para exibir no momento.'">
      </empty-state>
    } @else {
      <div
        echarts
        class="monitoramento-chart"
        [options]="chartOptions()">
      </div>
    }
  </div>

  @if (!isLoading() && !hasError() && hasData()) {
    <div class="monitoramento-card">
      <div class="monitoramento-card__header">
        <h2 class="monitoramento-card__title">Variação de duração vs execução anterior</h2>
        <p class="monitoramento-card__subtitle">Delta de duração</p>
      </div>

      @if (!hasDeltaData()) {
        <empty-state
          [title]="'Dados insuficientes'"
          [description]="'São necessárias pelo menos duas execuções para calcular a variação.'">
        </empty-state>
      } @else {
        <div
          echarts
          class="monitoramento-chart"
          [options]="deltaChartOptions()">
        </div>
      }
    </div>
  }
  }
</div>
